import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const integrationsApi = createApi({
    reducerPath: 'integrationsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getIntegrations: build.query({
            query: (data) => ({
                url: api.integrations.getIntegrations(),
                method: 'GET',
                params: data
            })
        }),
        updateIntegrations: build.mutation({
            query: (data) => ({
                url: api.integrations.updateIntegrations(),
                method: 'POST',
                body: data
            }),
        }),
        deleteIntegration: build.mutation({
            query: ({id, ...data}) => ({
                url: api.integrations.deleteIntegration(id),
                method: 'DELETE',
                body: data
            }),
        }),
    })
})

export const {useLazyGetIntegrationsQuery, useUpdateIntegrationsMutation, useDeleteIntegrationMutation} = integrationsApi